<template>
  <div>
    <div>
      <vs-popup
        :title="
          editMode
            ? 'ویرایش ' + $t('BaseSalePrice')
            : 'درج ' + $t('BaseSalePrice')
        "
        :active.sync="showModal"
      >
        <form>
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.title"
              name="title"
              :label="$t('Title')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('title')">{{
              errors.first("title")
            }}</span>
          </div>

          <div class="vx-col w-full mt-4">
            <vs-button
              type="filled"
              class="float-right mb-4"
              @click.prevent="submitForm"
              :disabled="disabled"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </form>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
export default {
  name: "saleManagement_Contract_Management_BaseSalePricePopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      editMode: false,
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createBaseSalePrice: "baseSalePrice/create",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          if (!this.editMode) {
            // create BaseSalePrice
            this.createBaseSalePrice(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                setTimeout(() => {
                  this.$emit("finish");
                  this.$validator.reset();
                  this.disabled = false;
                }, 0);
              });
            });
          } else {
            // edit BaseSalePrice
            console.log("edit mode");
          }
          this.disabled = false;
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        if (this.model.id) {
          // edit mode
          this.editMode = true;
        } else {
          this.editMode = false;
        }
      }
    },
  },
};
</script>

<style></style>
